module.exports = __webpack_public_path__ + "static/media/consultation_header.369404fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/consultation_header.png
// module id = 573
// module chunks = 0